import React, { useState, useEffect } from 'react';
import { Settings, Server, Cpu, Key, Bell, Mic, Save, Users } from 'lucide-react';
import { api } from '../services/api';
import UsersSection from './UsersSection';
import styles from './SettingsPage.module.css';

const Section = ({ icon: Icon, title, children }) => (
  <div className={styles.section}>
    <div className={styles.sectionHeader}>
      <Icon size={15} className="text-accent" />
      <span className={styles.sectionTitle}>{title}</span>
    </div>
    <div className={styles.sectionBody}>{children}</div>
  </div>
);

const Field = ({ label, children, hint }) => (
  <div className={styles.field}>
    <label className={styles.fieldLabel}>{label}</label>
    {children}
    {hint && <p className={styles.fieldHint}>{hint}</p>}
  </div>
);

export default function SettingsPage() {
  const [saved, setSaved] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  // Ruolo autoritativo dal server (può essere cambiato da un altro admin).
  useEffect(() => {
    api.get('/users/me')
      .then((me) => setIsAdmin(me.role === 'admin'))
      .catch(() => setIsAdmin(false));
  }, []);

  const save = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <Settings size={16} className="text-accent" />
        <h1 className={styles.title}>Impostazioni</h1>
      </div>

      <div className={styles.content}>

        {isAdmin && (
          <Section icon={Users} title="Utenti">
            <UsersSection />
          </Section>
        )}

        <Section icon={Server} title="Backend & Server">
          <Field label="API URL" hint="URL del backend FastAPI. Default: https://178.105.190.198.nip.io">
            <input className={styles.input} defaultValue="https://178.105.190.198.nip.io" />
          </Field>
        </Section>

        <Section icon={Cpu} title="LLM Locale (Ollama)">
          <Field label="Modello attivo" hint="Modello Ollama in uso. Deve essere scaricato: ollama pull <nome>">
            <select className={styles.select}>
              <option>llama3.1</option>
              <option>llama3.1:70b</option>
              <option>mistral</option>
              <option>qwen2.5:14b</option>
            </select>
          </Field>
          <Field label="Temperature" hint="0 = deterministico, 1 = creativo. Consigliato: 0.2">
            <input className={styles.input} type="number" defaultValue="0.2" min="0" max="1" step="0.1" />
          </Field>
        </Section>

        <Section icon={Key} title="Integrazioni">
          <Field label="Pipedrive API Token">
            <input className={styles.input} type="password" placeholder="Token API Pipedrive" />
          </Field>
          <Field label="Pipedrive Company Domain">
            <input className={styles.input} placeholder="nomeazienda" />
          </Field>
          <Field label="Gmail — Client ID">
            <input className={styles.input} type="password" placeholder="OAuth2 Client ID" />
          </Field>
          <Field label="Gmail — Refresh Token">
            <input className={styles.input} type="password" placeholder="Refresh Token (da gmail_auth.py)" />
          </Field>
          <Field label="Google Calendar ID" hint="Solitamente: 'primary'">
            <input className={styles.input} defaultValue="primary" />
          </Field>
        </Section>

        <Section icon={Mic} title="Voce">
          <Field label="Modello Whisper STT" hint="Dimensioni: tiny, base, small, medium, large">
            <select className={styles.select}>
              <option value="tiny">tiny (più veloce)</option>
              <option value="base" selected>base (consigliato)</option>
              <option value="small">small</option>
              <option value="medium">medium</option>
              <option value="large">large (più accurato)</option>
            </select>
          </Field>
          <Field label="Voce TTS Piper" hint="Voci italiane: it_IT-riccardo-x_low">
            <input className={styles.input} defaultValue="it_IT-riccardo-x_low" />
          </Field>
          <Field label="Wake Word">
            <input className={styles.input} defaultValue="jarvis" />
          </Field>
        </Section>

        <Section icon={Bell} title="Notifiche Push Mobile">
          <Field label="Gotify Server URL" hint="Self-hosted push server. Lascia vuoto per disabilitare.">
            <input className={styles.input} placeholder="http://192.168.1.100:8080" />
          </Field>
          <Field label="Gotify Token">
            <input className={styles.input} type="password" placeholder="Token applicazione" />
          </Field>
        </Section>

        <button className={`${styles.saveBtn} ${saved ? styles.saved : ''}`} onClick={save}>
          <Save size={15} />
          {saved ? '✓ Salvato' : 'Salva Impostazioni'}
        </button>

      </div>
    </div>
  );
}
